// @ts-check
import $ from 'jquery'
import { $number } from '../../utils/number.js'

export const LUCKY_CARD = 'luckyCard'

export const LADDER_GAME = 'ladderGame'

const GACHA = {
  [LUCKY_CARD]: {
    development:
      'https://poker-qa-static.pmang.com/lib/poker-lucky-card-game/index.iife.js',
    production:
      'https://poker-static.pmang.com/lib/poker-lucky-card-game/index.iife.js',
    tagName: 'poker-lucky-card-game',
    eventCode: 'lucky_card',
    claimEvent: 'StartLuckyCard',
    closeEvent: 'CloseLuckyCard',
    playEvent: '',
    successCode: 1,
    fetchOnInitRequired: true,
    fetchAfterClaimRequired: true,
  },

  [LADDER_GAME]: {
    development:
      'https://poker-qa-static.pmang.com/lib/poker-ladder-game/index.iife.js',
    production:
      'https://poker-static.pmang.com/lib/poker-ladder-game/index.iife.js',
    tagName: 'poker-ladder-game',
    eventCode: 'ghost_leg',
    claimEvent: 'Claim',
    closeEvent: 'Close',
    playEvent: 'Start',
    successCode: 1,
    fetchOnInitRequired: false,
    fetchAfterClaimRequired: false,
  },
}

export class GachaGame {
  constructor(env = 'dev', name = '') {
    /** @type {JQuery<HTMLElement>} */
    this.$container = $('#poker-mall-gacha')

    this.el = null

    this.apiPrefix = ''

    this.ctx = GACHA[name]

    if (!this.ctx) {
      throw new Error('GachaGame: invalid name')
    }

    this.gachaModule =
      env === 'live' || env === 'rdy'
        ? this.ctx.production
        : this.ctx.development

    console.log('Gacha initialized:', this.ctx)
  }

  init() {
    return this.load()
      .then(() => {
        const el = document.createElement(this.ctx.tagName)
        this.el = el
        this.$container.append(this.el)
        this.bindEvents()
      })
      .then(() => {
        if (this.ctx.fetchOnInitRequired) {
          return this.updateTickets()
        }
      })
      .then(() => {
        this.$container.show()
      })
  }

  close() {
    this.removeEvents()
    $(this.el).remove()
    this.$container.hide()
  }

  bindEvents() {
    if (!this.el) return

    this.removeEvents()

    const $el = $(this.el)

    $el.on(this.ctx.closeEvent, () => {
      this.close()
    })

    $el.on(this.ctx.claimEvent, () => {
      this.claimAndUpdateState()
    })
  }

  updateTickets() {
    return this.fetchTickets().then((tickets) => {
      this.setTickets(tickets)
    })
  }

  claimAndUpdateState() {
    return this.claim()
      .then((data) => {
        if (data.result === this.ctx.successCode) {
          const rewardValue = data.reward_money || 0
          this.setResultCode(this.ctx.successCode)
          this.setRewardDisplayName(data.goods_name)
          this.setRewardMoney($number(rewardValue).text()) // '0000억 0000만'
        } else {
          this.setResultCode(data.result)
          this.setRewardDisplayName('')
          this.setRewardMoney(null)
        }
      })
      .then(() => {
        if (this.ctx.playEvent && this.el instanceof HTMLElement) {
          setTimeout(() => {
            this.el.dispatchEvent(new CustomEvent(this.ctx.playEvent))
          }, 10)
        }
      })
      .then(() => {
        if (this.ctx.fetchAfterClaimRequired) {
          return this.updateTickets()
        }
      })
  }

  removeEvents() {
    if (!this.el) return

    const $el = $(this.el)
    $el.off(this.ctx.closeEvent)
    $el.off(this.ctx.startEvent)
  }

  load() {
    return new Promise((resolve, reject) => {
      const isAlreadyLoaded = customElements.get(this.ctx.tagName)

      if (isAlreadyLoaded) {
        resolve(true)
        return
      }

      $.getScript(this.gachaModule)
        .done(() => {
          resolve(true)
        })
        .fail((err) => {
          reject(err)
        })
    })
  }

  /** @param tickets {number} */
  setTickets(tickets) {
    if (!this.el) return
    this.el.tickets = tickets
  }

  /** @param reward {string} */
  setRewardMoney(value) {
    if (!this.el) return
    this.el.rewardMoney = value || '0'
  }

  setResultCode(resultCode) {
    if (!this.el) return
    this.el.resultCode = resultCode
  }

  setRewardDisplayName(name) {
    if (!this.el) return
    this.el.goodsName = name || '(없음)' // 사다리 뽑기
    this.el.goodsDispName = name || '(없음)' // 럭키 카드
  }

  /**
   * @returns {Promise<number>}
   */
  fetchTickets() {
    return fetch(
      `${this.apiPrefix}/api/7poker/mall/event/gacha/${this.ctx.eventCode}`,
      {
        credentials: 'include',
        headers: {
          contentType: 'application/json',
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok.')
        }

        return res.json()
      })
      .then((data) => {
        return data.result.card_cnt
      })
      .catch(() => {
        return 0
      })
  }

  /**
   * @returns {Promise<{goods_name: string | null, result: number, reward_money: number | null}>}
   */
  claim() {
    return fetch(
      `${this.apiPrefix}/api/7poker/mall/event/gacha/${this.ctx.eventCode}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          contentType: 'application/json',
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok.')
        }

        return res.json()
      })
      .then((data) => {
        return data.result
      })
      .catch((err) => {
        console.log(err)
        return {
          goods_name: '',
          result: -99,
          reward_money: null,
        }
      })
  }
}
